import * as yup from 'yup';

export const disputeSchema = yup.object().shape({
  enabled: yup.boolean(),
  autoDispute: yup.boolean(),
  emailNotification: yup.boolean(),
});
